import { Loader2, RefreshCw } from "lucide-react";
import { Button } from "@/components/ui/button";

interface CreanceAccrualActionProps {
  visible: boolean;
  isAccruing: boolean;
  result: string | null;
  onAccrueNow: () => void;
}

export function CreanceAccrualAction({
  visible,
  isAccruing,
  result,
  onAccrueNow,
}: CreanceAccrualActionProps) {
  if (!visible) return null;

  return (
    <div className="mb-4 flex items-center gap-3">
      <Button size="sm" variant="outline" onClick={onAccrueNow} disabled={isAccruing}>
        {isAccruing ? <Loader2 size={13} className="animate-spin" /> : <RefreshCw size={13} />}
        Déclencher l'accumulation maintenant
      </Button>
      {result && <span className="text-[11.5px] text-muted-foreground">{result}</span>}
    </div>
  );
}
